import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-500 py-8 px-3 border-t-4 border-brand-accent" data-id="element-109">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-110">
        <div className="inline-block bg-brand-accent text-black font-black px-4 py-1.5 rounded-full mb-4 text-xs tracking-widest uppercase shadow-md" data-id="element-111">
          ⚙️ KIT PROFE™ MANTENIMIENTO
        </div>

        <p className="text-sm md:text-base font-bold mb-3 max-w-xl text-gray-300 uppercase leading-relaxed" data-id="element-112">
          El sistema de materiales N°1 para docentes de Mantenimiento Industrial
          de escuelas técnicas en Argentina.
        </p>

        <p className="text-brand-accent font-black text-sm md:text-base neon-glow uppercase" data-id="element-113">
          Porque enseñar mantenimiento industrial en el taller no debería
          costarte todos los domingos.
        </p>
      </div>
    </footer>;
}